module.exports = __webpack_public_path__ + "static/media/flipVertical.d4080537.svg";